import { useKidsPolicy } from "@/components/features/_hooks/use-kids-policy/use-kids-policy";

import { useProductDummyRoomFormModelContext } from "../../../../../context";

export const useDummyRoomKidsPolicy = () => {
	const { viewModel, onSetViewModel } = useProductDummyRoomFormModelContext();
	const { kidsPolicy } = viewModel;

	return useKidsPolicy({ kidsPolicy, onSetViewModel });
};
